module.exports = __webpack_public_path__ + "static/media/A17.b7bab849.jpg";